import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import {
  GET_ACCESS_PROVIDER,
  getAccessProviderName,
} from "@dhn/shared/access-provider";

const EMPTY_VALUE = "-";

const normalizeText = (value) => (value || "").toString().trim();

const withEmptyValue = (fields) =>
  fields.map((field) => ({ ...field, value: normalizeText(field.value) || EMPTY_VALUE }));

// Datos del usuario de farmacia, call center o administración: proveedor (o
// empresa), sucursal y perfil. Con `providerName` no se consulta el proveedor.
export default function useAccessUserProfileDetails({
  isOpen,
  user,
  profile,
  providerLabel,
  providerName,
}) {
  const { data, loading: providerLoading } = useQuery(GET_ACCESS_PROVIDER, {
    skip: !isOpen || providerName !== undefined,
    fetchPolicy: "cache-first",
    errorPolicy: "all",
  });

  const loading = providerName === undefined && providerLoading;

  return useMemo(() => {
    const fullName =
      [user?.firstName, user?.lastName].map(normalizeText).filter(Boolean).join(" ") ||
      EMPTY_VALUE;

    return {
      loading,
      fullName,
      accessFields: withEmptyValue([
        {
          label: providerLabel,
          value: loading
            ? "Cargando..."
            : providerName ?? getAccessProviderName(data?.provider),
        },
        { label: "Sucursal", value: user?.branchOffice?.name },
        { label: "Perfil", value: profile?.name },
      ]),
      userFields: withEmptyValue([
        { label: "Nombre", value: fullName },
        { label: "Usuario", value: user?.username },
        { label: "Correo", value: user?.email },
      ]),
    };
  }, [data, loading, user, profile, providerLabel, providerName]);
}
